<template>
  <div>
    <CxAlert v-if="!cart.isMinimumCartValueReached()" variant="warning" :closable="false">
      <template #title>
        {{ translate("CART.CARD.ALERT.MINIMUM_VALUE_TITLE") }}
      </template>
      <template #body>
        {{
          translate("CART.CARD.ALERT.MINIMUM_VALUE_CONTENT", {
            missingForMinimumValue: localizeCurrency(cart.getMissingForMinimumValueAsAbsoluteDecimal()),
          })
        }}
      </template>
    </CxAlert>

    <BrandedButton
      v-if="canAddAnotherProductToCart"
      @click="addAnotherProductToCart"
      :isOutlined="isButtonOutlined"
      class="mt-5 w-100"
      data-test="add-item-btn"
    >
      {{ translate("CART.CARD.ADD_ITEM") }}
    </BrandedButton>
  </div>
</template>

<script setup lang="ts">
import useTranslate from "@/core/composables/translate";
import { useCartStore } from "@/core/store/cart/cartStore";
import { computed, defineEmits } from "vue";
import { storeToRefs } from "pinia";
import { CxAlert } from "@/designSystem";
import BrandedButton from "@/apps/shared/buyback/view/components/Button/BrandedButton.vue";

const { translate, localizeCurrency } = useTranslate();

const { cart, canAddAnotherProductToCart } = storeToRefs(useCartStore());

const emits = defineEmits(["addAnotherProductToCart"]);

const isButtonOutlined = computed(() => cart.value.isMinimumCartValueReached());

const addAnotherProductToCart = () => emits("addAnotherProductToCart");
</script>

<style scoped lang="scss">
.diag-card-footer {
  display: block;
}
</style>
